import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from 'services/api/api';
import { mapErrorToToastProps } from 'utils/forms/mapErrorToToastProps';

export const updateActivity = async body => {
	const response = await api.patch('/atividade', body);
	return response.data;
};

export const useEditActivity = (body, onClose) => {
	const queryClient = useQueryClient();
	const toast = useToast();

	return useMutation(() => updateActivity(body), {
		onSuccess: () => {
			queryClient.invalidateQueries(['activities-list']);
			onClose();

			toast({
				title: 'Atualizada com sucesso!',
				description: 'Atividade atualizada com sucesso.',
				position: 'bottom-left',
				status: 'success',
				duration: 8000,
				isClosable: true,
			});
		},
		onError: (error: any) => {
			const toastErrors: Array<any> = mapErrorToToastProps(
				error,
				'Erro ao cadastrar Família!'
			);
			toastErrors?.forEach(element => toast(element));
		},
	});
};
